// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__aOe7x","content":"styles_content__jHI6L","mask":"styles_mask__tz1ET","darkBackground":"styles_darkBackground__YYT58","container":"styles_container__uFlHi"};